import React, { useContext } from "react";
import { useState, useEffect, useRef } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";
// *******************toster****************************
import Card from "react-bootstrap/Card";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import JoditEditor from "jodit-react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import Select from "react-select";

library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData, IMG_URL, getDimension, Select2Data } =
    useContext(Context);

  const id = props.show;

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/masters/college-compaire/college/${id}`);
    console.log(response?.data);
    reset(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    watch,
    getValues,
    setValue,
    reset,
  } = useForm();
  console.log("getValues", getValues());
  const imageFile = watch("image");
  const imageFile2 = watch("logo");

  const onSubmit = async (data) => {
    try {
      const fromData = new FormData();
      fromData.append("name", data?.name);
      fromData.append("university_id", data?.university_id?.value);
      fromData.append("country_id", data?.country_id?.value);
      fromData.append("state_id", data?.state_id?.value);
      fromData.append("city_id", data?.city_id?.value);
      fromData.append("money_rating", data?.money_rating);
      fromData.append("campus_rating", data?.campus_rating);
      fromData.append("faculty_rating", data?.faculty_rating);
      fromData.append("infrastructure_rating", data?.infrastructure_rating);
      fromData.append("placement_rating", data?.placement_rating);
      fromData.append("rating", data?.rating);
      fromData.append("ownership", data?.ownership);
      fromData.append("establish_year", data?.establish_year);

      fromData.append("image", data?.image[0]);
      const courses = [];

      data.courses.forEach((val) => {
        const courseData = {
          course_type_id: val.course_type_id.value,
          course_id: val.course_id.value,
          specialization_id: val.specialization_id.value,
          batch_placement_percentage: val.batch_placement_percentage,
          total_fees: val.total_fees,
          tuition_fees: val.tuition_fees,
        
          qualification_percentage: val.qualification_percentage,
          mode: val.mode.value,
          median_salary: val.median_salary,
          highest_salary: val.highest_salary,
          emi_status: val.emi_status,
          placement_status: val.placement_status,
          study_hour: val.study_hour,
        };

        if (val.qualification_id) {
          courseData.qualification_id = val.qualification_id.map(
            (option) => option.value
          );
        }
        if (val.exam_id) {
          courseData.exam_id = val.exam_id.map((option) => option.value);
        }

        courses.push(courseData);
      });
      fromData.append("courses", JSON.stringify(courses));

      const eligibility = [];
      data.eligibility.forEach((val) => {
        const data = {
          qualification_id: val.qualification_id.value,
          cast_id: val.cast_id.value,
          percentage: val.percentage,
        };

        eligibility.push(data);
      });
      fromData.append("eligibility", JSON.stringify(eligibility));

      if (data.facility_id) {
        fromData.append(
          "facility_id",
          JSON.stringify(data.facility_id.map((option) => option.value))
        );
      }
      // if (data.ranking_id) {
      //   fromData.append(
      //     "ranking_id",
      //     JSON.stringify(data.ranking_id.map((option) => option.value))
      //   );
      // }
      const ranking = [];
      data.ranking.forEach((val) => {
        const data = {
          ranking: val.ranking,
          ranking_id: val.ranking_id.value,
        };

        ranking.push(data);
      });
      fromData.append("ranking", JSON.stringify(ranking));

      const response = await postData(
        `/masters/college-compaire/college/${id}`,
        fromData
      );
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [qualification, setQualification] = useState([]);
  const GetAllqualification = async () => {
    const response = await getData("/allqualification");

    if (response?.success) {
      setQualification(await Select2Data(response?.data, "qualification_id"));
    }
  };

  useEffect(() => {
    GetAllqualification();
  }, []);

  const mode = [
    { value: "Online", label: "Online" },
    { value: "Offline", label: "Offline" },
    { value: "Hybrid", label: "Hybrid" },
  ];

  const {
    fields: coursesFields,
    append: appendCourses,
    remove: removeCourses,
  } = useFieldArray({
    control,
    name: "courses",
  });

  const [addOnError, setAddOnError] = useState("");

  useEffect(() => {
    register("courses", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setAddOnError(isValid ? "" : "At least one courses is required");
        return isValid;
      },
    });
  }, [register]);

  const {
    fields: eligibilityFields,
    append: appendEligibility,
    remove: removeEligibility,
  } = useFieldArray({
    control,
    name: "eligibility",
  });
  const [eligibilityError, setEligibilityError] = useState("");

  useEffect(() => {
    register("eligibility", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setEligibilityError(
          isValid ? "" : "At least one eligibility is required"
        );
        return isValid;
      },
    });
  }, [register]);

  const {
      fields: rankingFields,
      append: appendRanking,
      remove: removeRanking,
    } = useFieldArray({
      control,
      name: "ranking",
    });
    const [rankingError, setRankingError] = useState("");
  
    useEffect(() => {
      register("ranking", {
        validate: (value) => {
          const isValid = value && value.length > 0;
          setRankingError(
            isValid ? "" : "At least one ranking is required"
          );
          return isValid;
        },
      });
    }, [register]);

  const handleKeyPress = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    const charStr = String.fromCharCode(charCode);

    // Allow only digits and a single dot (.)
    if (!/[0-9.]$/.test(charStr)) {
      event.preventDefault();
    }

    // Prevent multiple dots
    if (event.target.value.includes(".") && charStr === ".") {
      event.preventDefault();
    }
  };
  const handleKeyPressPercentage = (event) => {
    const charCode = event.which ? event.which : event.keyCode;
    const charStr = String.fromCharCode(charCode);

    // Allow only digits and a single dot (.)
    if (!/[0-9.]$/.test(charStr)) {
      event.preventDefault();
    }

    // Prevent multiple dots
    if (event.target.value.includes(".") && charStr === ".") {
      event.preventDefault();
    }
  };

  const [university, setUniversity] = useState([]);

  const GetAllUniversity = async () => {
    const response = await getData("/alluniversity");

    if (response?.success) {
      setUniversity(await Select2Data(response?.data, "university_id"));
    }
  };

  const [courseType, setCourseType] = useState([]);

  const GetAllCourseType = async () => {
    const response = await getData("/allcoursetype");

    if (response?.success) {
      setCourseType(await Select2Data(response?.data, "course_type_id"));
    }
  };

  const [course, setCourse] = useState([]);

  const GetAllCourse = async (id) => {
    const response = await getData(`/allcourse/${id}`);

    if (response?.success) {
      setCourse(await Select2Data(response?.data, "course_id"));
    }
  };

  const [specialization, setSpecialization] = useState([]);

  const GetAllSpecialization = async (id) => {
    const response = await getData(`/allSpecialization-course/${id}`);

    if (response?.success) {
      setSpecialization(await Select2Data(response?.data, "specialization_id"));
    }
  };

  useEffect(() => {
    GetAllUniversity();
    GetAllCourseType();
  }, []);

  const [country, setCountry] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const GetAllCountries = async () => {
    const response = await getData("/allcountry");

    if (response?.success) {
      setCountry(await Select2Data(response?.data, "country_id"));
    }
  };

  const GetAllStates = async (id) => {
    const response = await getData(`/allstate/${id}`);

    if (response?.success) {
      setStates(await Select2Data(response?.data, "state_id"));
    }
  };

  const GetAllCities = async (id) => {
    const response = await getData(`/allcity/${id}`);

    if (response?.success) {
      setCities(await Select2Data(response?.data, "city_id"));
    }
  };

  useEffect(() => {
    GetAllCountries();
    GetAllStates();
    GetAllCities();
  }, []);

  const [cast, setCast] = useState([]);

  const GetAllCast = async () => {
    const response = await getData("/allcast");

    if (response?.success) {
      setCast(await Select2Data(response?.data, "cast_id"));
    }
  };
  const [facility, setFacility] = useState([]);

  const GetAllFacility = async () => {
    const response = await getData("/allfacility");

    if (response?.success) {
      setFacility(await Select2Data(response?.data, "facility_id"));
    }
  };
  const [ranking, setRanking] = useState([]);

  const GetAllRanking = async () => {
    const response = await getData("/allranking");

    if (response?.success) {
      setRanking(await Select2Data(response?.data, "ranking_id"));
    }
  };
  const [exams, setExams] = useState([]);

  const GetAllExams = async () => {
    const response = await getData("/allexams");

    if (response?.success) {
      setExams(await Select2Data(response?.data, "exam_id"));
    }
  };

  useEffect(() => {
    GetAllExams();
    GetAllRanking();
    GetAllFacility();
    GetAllCast();
  }, []);

  const currentYear = new Date().getFullYear();

  return (
    <>
      <Modal
        onHide={props.handleClose}
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit College
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={() => handleSubmit(onSubmit)}
            role="form"
            className="countryclass"
          >
            <Row>
              {/* name */}
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>University</Form.Label>

                    <Controller
                      name="University" // name of the field
                      {...register("university_id", {
                        required: "University is required",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.university_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={university}
                        />
                      )}
                    />

                    {errors.university_id && (
                      <span className="text-danger">
                        {errors.university_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Country</Form.Label>

                    <Controller
                      name="country_id" // name of the field
                      {...register("country_id", {
                        required: "Select Country",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.country_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={country}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value); // Update Controller's value
                            GetAllStates(selectedOption.value);
                            setValue("country_id", selectedOption);
                            setValue("state_id", null);
                            setValue("city_id", null);
                          }}
                        />
                      )}
                    />

                    {errors.country_id && (
                      <span className="text-danger">
                        {errors.country_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>State</Form.Label>

                    <Controller
                      name="state_id" // name of the field
                      {...register("state_id", {
                        required: "Select State",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.state_id ? "red" : baseStyles,
                            }),
                          }}
                          {...field}
                          options={states}
                          onChange={(selectedOption) => {
                            field.onChange(selectedOption.value); // Update Controller's value
                            GetAllCities(selectedOption.value);
                            setValue("state_id", selectedOption);
                            setValue("city_id", null);
                          }}
                        />
                      )}
                    />

                    {errors.state_id && (
                      <span className="text-danger">
                        {errors.state_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>City</Form.Label>

                    <Controller
                      name="city_id" // name of the field
                      {...register("city_id", {
                        required: "Select City",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.city_id ? "red" : baseStyles,
                            }),
                          }}
                          {...field}
                          options={cities}
                        />
                      )}
                    />

                    {errors.city_id && (
                      <span className="text-danger">
                        {errors.city_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Facility</Form.Label>

                    <Controller
                      name="Facility" // name of the field
                      {...register("facility_id", {
                        required: "Facility is required",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isMulti
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.facility_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={facility}
                        />
                      )}
                    />

                    {errors.facility_id && (
                      <span className="text-danger">
                        {errors.facility_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              {/* <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Ranking</Form.Label>

                    <Controller
                      name="ranking" // name of the field
                      {...register("ranking_id", {
                        required: "ranking is required",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isMulti
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.ranking_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={ranking}
                        />
                      )}
                    />

                    {errors.ranking_id && (
                      <span className="text-danger">
                        {errors.ranking_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col> */}
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label> Name</Form.Label>
                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.name,
                      })}
                      type="text"
                      {...register("name", {
                        required: "Name is required",
                        // maxLength: {
                        //   value: 50,
                        //   message: "Title must be at most 50 characters long",
                        // },
                      })}
                      placeholder="name"
                    />
                  </Form.Group>
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </div>{" "}
              </Col>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Establish Year</Form.Label>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name="establish_year"
                        min="0"
                        max={currentYear} // Set the max attribute to the current year
                        placeholder="Year"
                        className={classNames("", {
                          "is-invalid": errors?.establish_year,
                        })}
                        {...register(`establish_year`, {
                          required: "Year is required",
                          validate: (value) =>
                            (value > 0 && value <= currentYear) ||
                            `must be  ${currentYear} Or Less Than This`,
                        })}
                      />

                      {errors?.establish_year && (
                        <span className="text-danger">
                          {errors?.establish_year.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Ownership</Form.Label>
                  <Form.Group>
                    <Form.Control
                      className={classNames("", {
                        "is-invalid": errors?.ownership,
                      })}
                      type="text"
                      {...register("ownership", {
                        required: "Ownership is required",
                        // maxLength: {
                        //   value: 50,
                        //   message: "Title must be at most 50 characters long",
                        // },
                      })}
                      placeholder="Ownership"
                    />
                  </Form.Group>
                  {errors.ownership && (
                    <span className="text-danger">
                      {errors.ownership.message}
                    </span>
                  )}
                </div>{" "}
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Rating</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Ratings"
                      className={classNames("", {
                        "is-invalid": errors?.rating,
                      })}
                      {...register("rating", {
                        required: "ratings Is Required",
                        min: {
                          value: 1,
                          message: "Rating must be at least 1",
                        },
                        max: {
                          value: 5,
                          message: "Rating cannot exceed 5",
                        },
                      })}
                      onKeyPress={handleKeyPress}
                    />
                  </Form.Group>
                  {errors.rating && (
                    <span className="text-danger">{errors.rating.message}</span>
                  )}
                </div>{" "}
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Placement Rating</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Placement Ratings"
                      className={classNames("", {
                        "is-invalid": errors?.placement_rating,
                      })}
                      {...register("placement_rating", {
                        required: "ratings Is Required",
                        min: {
                          value: 1,
                          message: "Rating must be at least 1",
                        },
                        max: {
                          value: 5,
                          message: "Rating cannot exceed 5",
                        },
                      })}
                      onKeyPress={handleKeyPress}
                    />
                  </Form.Group>
                  {errors.placement_rating && (
                    <span className="text-danger">
                      {errors.placement_rating.message}
                    </span>
                  )}
                </div>{" "}
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Infrastructure Rating</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Ratings"
                      className={classNames("", {
                        "is-invalid": errors?.infrastructure_rating,
                      })}
                      {...register("infrastructure_rating", {
                        required: "ratings Is Required",
                        min: {
                          value: 1,
                          message: "Rating must be at least 1",
                        },
                        max: {
                          value: 5,
                          message: "Rating cannot exceed 5",
                        },
                      })}
                      onKeyPress={handleKeyPress}
                    />
                  </Form.Group>
                  {errors.infrastructure_rating && (
                    <span className="text-danger">
                      {errors.infrastructure_rating.message}
                    </span>
                  )}
                </div>{" "}
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Crowd & Campus Rating</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Ratings"
                      className={classNames("", {
                        "is-invalid": errors?.campus_rating,
                      })}
                      {...register("campus_rating", {
                        required: "ratings Is Required",
                        min: {
                          value: 1,
                          message: "Rating must be at least 1",
                        },
                        max: {
                          value: 5,
                          message: "Rating cannot exceed 5",
                        },
                      })}
                      onKeyPress={handleKeyPress}
                    />
                  </Form.Group>
                  {errors.campus_rating && (
                    <span className="text-danger">
                      {errors.campus_rating.message}
                    </span>
                  )}
                </div>{" "}
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Value for Money Rating</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Ratings"
                      className={classNames("", {
                        "is-invalid": errors?.money_rating,
                      })}
                      {...register("money_rating", {
                        required: "ratings Is Required",
                        min: {
                          value: 1,
                          message: "Rating must be at least 1",
                        },
                        max: {
                          value: 5,
                          message: "Rating cannot exceed 5",
                        },
                      })}
                      onKeyPress={handleKeyPress}
                    />
                  </Form.Group>
                  {errors.money_rating && (
                    <span className="text-danger">
                      {errors.money_rating.message}
                    </span>
                  )}
                </div>{" "}
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Faculty Rating</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Ratings"
                      className={classNames("", {
                        "is-invalid": errors?.faculty_rating,
                      })}
                      {...register("faculty_rating", {
                        required: "ratings Is Required",
                        min: {
                          value: 1,
                          message: "Rating must be at least 1",
                        },
                        max: {
                          value: 5,
                          message: "Rating cannot exceed 5",
                        },
                      })}
                      onKeyPress={handleKeyPress}
                    />
                  </Form.Group>
                  {errors.faculty_rating && (
                    <span className="text-danger">
                      {errors.faculty_rating.message}
                    </span>
                  )}
                </div>{" "}
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Image</Form.Label>
                  <Form.Control
                    className={classNames("", {
                      "is-invalid": errors?.image,
                    })}
                    type="file"
                    {...register("image", {
                      validate: async (value) => {
                        if (typeof value !== "string") {
                          const fileTypes = ["jpg", "png", "jpeg"];
                          const fileType = value[0].name?.split(".")[1];

                          if (!fileTypes.includes(fileType)) {
                            // return `please upload a valid file format. (${fileTypes})`;
                          }

                          // const sizes = await getDimension(value[0]);
                          // if (sizes.width !== 1296 && sizes.height !== 385) {
                          //   // return "Image width and height must be 1296 px and 385 px";
                          // }

                          // const fileSize = Math.round(value[0].size / 1024);
                          // if (fileSize > 1000) {
                          //   // return "file size must be lower than 1000kb";
                          // }
                        }
                      },
                    })}
                    accept=".jpg, .jpeg, .png"
                  />
                  {errors.image && (
                    <span className="text-danger">{errors.image.message}</span>
                  )}
                </div>{" "}
              </Col>
              <Col lg={6} className="text-center">
                <div className="main-form-section mt-3">
                  <Form.Label>Image Preview</Form.Label>
                  {typeof getValues("image") == "string" ? (
                    <div className="image-preview-container">
                      <img
                        src={IMG_URL + getValues("image")}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "150px", height: "130px" }}
                      />
                    </div>
                  ) : (
                    imageFile &&
                    imageFile?.length > 0 && (
                      <div className="image-preview-container">
                        <img
                          // src={URL.createObjectURL(getValues("image")[0])}
                          src={URL?.createObjectURL(imageFile[0])}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "100px", height: "100px" }}
                        />
                      </div>
                    )
                  )}
                </div>
              </Col>
              {/* <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-start">
                    {" "}
                
                    <Col sm={12}>
                      <Form.Label className="text-center">
                        Description
                      </Form.Label>
                      <Form.Group>
                        <Controller
                          name="description" // Provide the field name
                          control={control} // Pass the control object from useForm()
                          rules={{ required: "Description is required" }} // Validation rules
                          render={({ field }) => (
                            <JoditEditor
                              value={field.value}
                              onChange={(newContent) =>
                                field.onChange(newContent)
                              }
                              onBlur={field.onBlur}
                              className={classNames("", {
                                "is-invalid": !!errors.description,
                              })}
                              placeholder="Description"
                            />
                          )}
                        />
                      </Form.Group>
                      {errors.description && (
                        <span className="text-danger">
                          {errors.description.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col> */}
              <br></br>
              <h5>Courses</h5>
              {addOnError && <div className="text-danger">{addOnError}</div>}
              <hr />
              {coursesFields.map((variant, index) => (
                <div key={variant.id} className="main-form-section mt-3">
                  <Row>
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Course Type</Form.Label>
                          <Controller
                            name={`courses.${index}.course_type_id`} // name of the field
                            {...register(`courses.${index}.course_type_id`, {
                              required: "Select Course Type",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.courses?.[index]
                                      ?.course_type_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={courseType}
                                onChange={(selectedOption) => {
                                  field.onChange(selectedOption.value); // Update Controller's value
                                  GetAllCourse(selectedOption.value);
                                  setValue(
                                    `courses.${index}.course_type_id`,
                                    selectedOption
                                  );
                                  setValue(`courses.${index}.courses_id`, null);
                                }}
                              />
                            )}
                          />
                          {errors?.courses?.[index]?.course_type_id && (
                            <span className="text-danger">
                              {errors?.courses?.[index]?.course_type_id.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Course</Form.Label>
                          <Controller
                            name={`courses.${index}.course_id`} // name of the field
                            {...register(`courses.${index}.course_id`, {
                              required: "Select Course",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.courses?.[index]
                                      ?.course_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={course}
                                onChange={(selectedOption) => {
                                  field.onChange(selectedOption.value); // Update Controller's value
                                  GetAllSpecialization(selectedOption.value);
                                  setValue(
                                    `courses.${index}.course_id`,
                                    selectedOption
                                  );
                                  setValue(
                                    `courses.${index}.specialization_id`,
                                    null
                                  );
                                }}
                              />
                            )}
                          />
                          {errors?.courses?.[index]?.course_id && (
                            <span className="text-danger">
                              {errors?.courses?.[index]?.course_id.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Specialization</Form.Label>
                          <Controller
                            name={`courses.${index}.specialization_id`} // name of the field
                            {...register(`courses.${index}.specialization_id`, {
                              required: "Select specialization",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.courses?.[index]
                                      ?.specialization_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={specialization}
                              />
                            )}
                          />
                          {errors?.courses?.[index]?.specialization_id && (
                            <span className="text-danger">
                              {
                                errors?.courses?.[index]?.specialization_id
                                  .message
                              }
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Qualification</Form.Label>
                          <Controller
                            name={`courses.${index}.qualification_id`} // name of the field
                            {...register(`courses.${index}.qualification_id`, {
                              required: "Select Qualification",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                isMulti
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.courses?.[index]
                                      ?.qualification_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={qualification}
                              />
                            )}
                          />
                          {errors?.courses?.[index]?.qualification_id && (
                            <span className="text-danger">
                              {
                                errors?.courses?.[index]?.qualification_id
                                  .message
                              }
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Exams</Form.Label>
                          <Controller
                            name={`courses.${index}.exam_id`} // name of the field
                            {...register(`courses.${index}.exam_id`, {
                              required: "Select Exams",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                isMulti
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.courses?.[index]
                                      ?.exam_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={exams}
                              />
                            )}
                          />
                          {errors?.courses?.[index]?.exam_id && (
                            <span className="text-danger">
                              {errors?.courses?.[index]?.exam_id.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Mode</Form.Label>
                          <Controller
                            name={`courses.${index}.mode`} // name of the field
                            {...register(`courses.${index}.mode`, {
                              required: "Select mode",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.courses?.[index]
                                      ?.qualification_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={mode}
                              />
                            )}
                          />
                          {errors?.courses?.[index]?.mode && (
                            <span className="text-danger">
                              {errors?.courses?.[index]?.mode.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Highest Salary ₹</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`courses.${index}.highest_salary`}
                              placeholder="Highest Salary"
                              min="0" // Ensure no negative values are allowed
                              className={classNames("", {
                                "is-invalid":
                                  errors?.courses?.[index]?.highest_salary,
                              })}
                              {...register(`courses.${index}.highest_salary`, {
                                required: "Highest Salary is required",
                                validate: (value) =>
                                  value > 0 ||
                                  "Highest Salary must be greater than 0",
                              })}
                              onKeyPress={handleKeyPress}
                            />

                            {errors?.courses?.[index]?.highest_salary && (
                              <span className="text-danger">
                                {
                                  errors?.courses?.[index]?.highest_salary
                                    .message
                                }
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Median Salary ₹</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`courses.${index}.median_salary`}
                              placeholder="Median Salary"
                              min="0" // Ensure no negative values are allowed
                              className={classNames("", {
                                "is-invalid":
                                  errors?.courses?.[index]?.median_salary,
                              })}
                              {...register(`courses.${index}.median_salary`, {
                                required: "Highest Salary is required",
                                validate: (value) =>
                                  value > 0 ||
                                  "Median Salary must be greater than 0",
                              })}
                              onKeyPress={handleKeyPress}
                            />

                            {errors?.courses?.[index]?.median_salary && (
                              <span className="text-danger">
                                {
                                  errors?.courses?.[index]?.median_salary
                                    .message
                                }
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Total Fees ₹</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`courses.${index}.total_fees`}
                              placeholder="Total Fee"
                              min="0" // Ensure no negative values are allowed
                              className={classNames("", {
                                "is-invalid":
                                  errors?.courses?.[index]?.total_fees,
                              })}
                              {...register(`courses.${index}.total_fees`, {
                                required: "Highest Salary is required",
                                validate: (value) =>
                                  value > 0 ||
                                  "Total Fee must be greater than 0",
                              })}
                              onKeyPress={handleKeyPress}
                            />

                            {errors?.courses?.[index]?.total_fees && (
                              <span className="text-danger">
                                {errors?.courses?.[index]?.total_fees.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Tuition Fees ₹</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`courses.${index}.tuition_fees`}
                              placeholder="Tuition Fees"
                              min="0" // Ensure no negative values are allowed
                              className={classNames("", {
                                "is-invalid":
                                  errors?.courses?.[index]?.tuition_fees,
                              })}
                              {...register(`courses.${index}.tuition_fees`, {
                                required: "Tuition Fees is required",
                                validate: (value) =>
                                  value > 0 ||
                                  "Tuition Fees must be greater than 0",
                              })}
                              onKeyPress={handleKeyPress}
                            />

                            {errors?.courses?.[index]?.tuition_fees && (
                              <span className="text-danger">
                                {errors?.courses?.[index]?.tuition_fees.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Qualification Percentage</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`courses.${index}.qualification_percentage`}
                              placeholder="Qualification Percentage"
                              className={classNames("", {
                                "is-invalid":
                                  errors?.courses?.[index]
                                    ?.qualification_percentage,
                              })}
                              {...register(
                                `courses.${index}.qualification_percentage`,
                                {
                                  required:
                                    "Qualification Percentage is required",
                                  pattern: {
                                    value:
                                      /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{1,2})?)$/,
                                    message:
                                      "Enter a valid percentage (0 - 100)",
                                  },
                                }
                              )}
                              onKeyPress={handleKeyPressPercentage}
                            />

                            {errors?.courses?.[index]
                              ?.qualification_percentage && (
                              <span className="text-danger">
                                {
                                  errors?.courses?.[index]
                                    ?.qualification_percentage.message
                                }
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Batch Placement Percentage</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`courses.${index}.batch_placement_percentage`}
                              placeholder="Batch Placement Percentage"
                              className={classNames("", {
                                "is-invalid":
                                  errors?.courses?.[index]
                                    ?.batch_placement_percentage,
                              })}
                              {...register(
                                `courses.${index}.batch_placement_percentage`,
                                {
                                  required:
                                    "Batch Placement Percentage is required",
                                  pattern: {
                                    value:
                                      /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{1,2})?)$/,
                                    message:
                                      "Enter a valid percentage (0 - 100)",
                                  },
                                }
                              )}
                              onKeyPress={handleKeyPressPercentage}
                            />

                            {errors?.courses?.[index]
                              ?.batch_placement_percentage && (
                              <span className="text-danger">
                                {
                                  errors?.courses?.[index]
                                    ?.batch_placement_percentage.message
                                }
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Study Hour</Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`courses.${index}.study_hour`}
                              placeholder="Study Hour"
                              className={classNames("", {
                                "is-invalid":
                                  errors?.courses?.[index]?.study_hour,
                              })}
                              {...register(`courses.${index}.study_hour`, {
                                required: "Study Hour is required",
                                pattern: {
                                  value:
                                    /^(100(\.0{1,2})?|[1-9]?[0-9](\.[0-9]{1,2})?)$/,
                                  message:
                                    "Enter a valid number between 1 and 100",
                                },
                              })}
                              onKeyPress={handleKeyPressPercentage}
                            />

                            {errors?.courses?.[index]?.study_hour && (
                              <span className="text-danger">
                                {errors.courses[index].study_hour.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>Placement Status</Form.Label>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              label="Placement Status"
                              {...register(`courses.${index}.placement_status`)}
                            />

                            {errors?.courses?.[index]?.placement_status && (
                              <span className="text-danger">
                                {
                                  errors?.courses?.[index]?.placement_status
                                    .message
                                }
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label>EMI Status</Form.Label>
                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              label="EMI Status"
                              {...register(`courses.${index}.emi_status`)}
                            />

                            {errors?.courses?.[index]?.emi_status && (
                              <span className="text-danger">
                                {errors?.courses?.[index]?.emi_status.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    <Col lg={3}>
                      <button
                        className="btn btn-danger mt-3"
                        type="button"
                        onClick={() => removeCourses(index)}
                      >
                        Remove Course
                      </button>
                    </Col>
                  </Row>
                </div>
              ))}
              <div className="main-form-section mt-3"></div>
              <hr />
              <div className="text-center">
                {/* <button
                          type="button"
                          className="btn btn-danger mb-3"
                          onClick={() => removeAddOn({})}
                        >
                          - Remove Add on
                        </button> */}
              </div>
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-primary mb-3"
                  onClick={() => appendCourses({})}
                >
                  + Add Course
                </button>
              </div>
              <br></br>
              <h5>Eligibility</h5>
              {eligibilityError && (
                <div className="text-danger">{eligibilityError}</div>
              )}
              <hr />
              {eligibilityFields.map((variant, index) => (
                <div key={variant.id} className="main-form-section mt-3">
                  <Row>
                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Cast</Form.Label>
                          <Controller
                            name={`eligibility.${index}.cast_id`} // name of the field
                            {...register(`eligibility.${index}.cast_id`, {
                              required: "Select specialization",
                            })}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.courses?.[index]
                                      ?.cast_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={cast}
                              />
                            )}
                          />
                          {errors?.courses?.[index]?.cast_id && (
                            <span className="text-danger">
                              {errors?.courses?.[index]?.cast_id.message}
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="row justify-content-center mb-2">
                          <Form.Label>Qualification</Form.Label>
                          <Controller
                            name={`eligibility.${index}.qualification_id`} // name of the field
                            {...register(
                              `eligibility.${index}.qualification_id`,
                              {
                                required: "Select Qualification",
                              }
                            )}
                            control={control}
                            render={({ field }) => (
                              <Select
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    borderColor: errors?.courses?.[index]
                                      ?.qualification_id
                                      ? "red"
                                      : baseStyles,
                                  }),
                                }}
                                {...field}
                                options={qualification}
                              />
                            )}
                          />
                          {errors?.courses?.[index]?.qualification_id && (
                            <span className="text-danger">
                              {
                                errors?.courses?.[index]?.qualification_id
                                  .message
                              }
                            </span>
                          )}
                        </Row>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className="main-form-section mt-3">
                        <Row className="justify-content-center">
                          <Form.Label> Percentage </Form.Label>
                          <Form.Group>
                            <Form.Control
                              type="text"
                              name={`eligibility.${index}.percentage`}
                              placeholder="Qualification Percentage"
                              className={classNames("", {
                                "is-invalid":
                                  errors?.courses?.[index]?.percentage,
                              })}
                              {...register(`eligibility.${index}.percentage`, {
                                required: " Percentage is required",
                                pattern: {
                                  value:
                                    /^(100(\.0{1,2})?|[0-9]{1,2}(\.[0-9]{1,2})?)$/,
                                  message: "Enter a valid percentage (0 - 100)",
                                },
                              })}
                              onKeyPress={handleKeyPressPercentage}
                            />

                            {errors?.courses?.[index]?.percentage && (
                              <span className="text-danger">
                                {errors?.courses?.[index]?.percentage.message}
                              </span>
                            )}
                          </Form.Group>
                        </Row>
                      </div>
                    </Col>

                    <Col lg={3}>
                      <button
                        className="btn btn-danger mt-3"
                        type="button"
                        onClick={() => removeEligibility(index)}
                      >
                        Remove Eligibility
                      </button>
                    </Col>
                  </Row>
                </div>
              ))}
              <div className="main-form-section mt-3"></div>
              <hr />
              <div className="text-center">
                {/* <button
                          type="button"
                          className="btn btn-danger mb-3"
                          onClick={() => removeAddOn({})}
                        >
                          - Remove Add on
                        </button> */}
              </div>
              <div className="text-center">
                <button
                  type="button"
                  className="btn btn-primary mb-3"
                  onClick={() => appendEligibility({})}
                >
                  + Add Eligibility
                </button>
              </div>

                <h5>Ranking</h5>
                            {rankingError && (
                              <div className="text-danger">{rankingError}</div>
                            )}
                            <hr />
                            {rankingFields.map((variant, index) => (
                              <div key={variant.id} className="main-form-section mt-3">
                                <Row>
                                  <Col md={3}>
                                    <div className="main-form-section mt-3">
                                      <Row className="row justify-content-center mb-2">
                                        <Form.Label>ranking</Form.Label>
                                        <Controller
                                          name={`ranking.${index}.ranking_id`} // name of the field
                                          {...register(`ranking.${index}.ranking_id`, {
                                            required: "Select ranking",
                                          })}
                                          control={control}
                                          render={({ field }) => (
                                            <Select
                                              styles={{
                                                control: (baseStyles) => ({
                                                  ...baseStyles,
                                                  borderColor: errors?.ranking?.[index]
                                                    ?.cast_id
                                                    ? "red"
                                                    : baseStyles,
                                                }),
                                              }}
                                              {...field}
                                              options={ranking}
                                            />
                                          )}
                                        />
                                        {errors?.ranking?.[index]?.ranking_id && (
                                          <span className="text-danger">
                                            {errors?.ranking?.[index]?.ranking_id.message}
                                          </span>
                                        )}
                                      </Row>
                                    </div>
                                  </Col>
              
                                  <Col md={3}>
                                    <div className="main-form-section mt-3">
                                      <Row className="justify-content-center">
                                        <Form.Label> Ranking </Form.Label>
                                        <Form.Group>
                                          <Form.Control
                                            type="text"
                                            name={`ranking.${index}.ranking`}
                                            placeholder="ranking"
                                            className={classNames("", {
                                              "is-invalid":
                                                errors?.ranking?.[index]
                                                  ?.ranking,
                                            })}
                                            {...register(
                                              `ranking.${index}.ranking`,
                                              {
                                                required:
                                                  " ranking is required",
                                                  min: {
                                                    value: 1,
                                                    message: "Rating must be at least 1",
                                                  },
                                                  max: {
                                                    value: 5,
                                                    message: "Rating cannot exceed 5",
                                                  },
                                              }
                                            )}
                                            onKeyPress={handleKeyPress}
                                          />
              
                                          {errors?.ranking?.[index]
                                            ?.ranking && (
                                            <span className="text-danger">
                                              {
                                                errors?.ranking?.[index]
                                                  ?.ranking.message
                                              }
                                            </span>
                                          )}
                                        </Form.Group>
                                      </Row>
                                    </div>
                                  </Col>
              
                                  <Col lg={3}>
                                    <button
                                      className="btn btn-danger mt-3"
                                      type="button"
                                      onClick={() => removeRanking(index)}
                                    >
                                      Remove Ranking
                                    </button>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            <div className="main-form-section mt-3"></div>
                            <hr />
                            <div className="text-center">
                            
                            </div>
                            <div className="text-center">
                              <button
                                type="button"
                                className="btn btn-primary mb-3"
                                onClick={() => appendRanking({})}
                              >
                                + Add Ranking
                              </button>
                            </div>
            </Row>

            {/* Buttons */}
            <Row className="justify-content-center mt-5 pb-3">
              <Col sm={6} className="d-flex justify-content-center">
                <CancelButton name={"Cancel"} handleClose={props.handleClose} />
                <SaveButton
                  name={"Save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
